import {
	Component,
	OnInit,
	ChangeDetectorRef,
	AfterViewInit
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../../services/global/global.service";
import { Observable, Subscription } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { RouteFrom } from "../../../models/routeFrom";

import { DMVDataService } from "../../../services/dmv/dmv-data.service";
import { DmvRegistrationManual } from "../../../models/dmv/dmvRegistrationManual";
import { DmvRegistration } from "../../../models/dmv/dmvRegistration";
import { Renewal } from "../../../models/dmv/renewal";
import { RenewalItem } from "../../../models/dmv/renewalItem";
import { Address } from "../../../models/dmv/address";
import { DmvFee } from "../../../models/dmv/dmvFee";

import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { RenewalResponse } from "src/app/models/dmv/renewal-response";
import { AppUtil } from "../../../utils/app.util";

import { ServiceFeeAmountResponse } from "src/app/models/dmv/service-fee-amount.response";
import { AppConfigUtil } from "src/app/utils/app-config.util";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { Countries } from "src/app/models/dmv/countries";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { BillingAccount } from "src/app/models/user/billingAccount";
import { Agencies, Registration } from "src/app/models/dmv/models";
import { BillingAccountField } from "src/app/models/user/billingAccountField";
import { USERDataService } from "src/app/services/user/user-data.service";
import { UserProfile } from "src/app/models/user/userProfile";
import { DmvRegistrationDuplicate } from "src/app/models/dmv/dmvRegistrationDuplicate";

@Component({
	selector: "app-review-cart",
	templateUrl: "./review-cart.component.html",
	styleUrls: ["./review-cart.component.css"]
})
export class DmvReviewCartComponent implements OnInit, AfterViewInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public dmvDataService: DMVDataService,
		public megStoreService: MEGStoreService,
		public userStoreService: USERStoreService,
		public userDataService: USERDataService,
		private cd: ChangeDetectorRef
	) {}

	public openRennewalReminderModel: boolean = false;
	public addToProfileRegistraion: Registration;
	public openloginModel: boolean = true;
	public isloading: boolean = false;
	public errorMessage: string = "";
	public renewalRequest: Renewal = Object.assign({});
	public megAppFee: number;
	//public megAppFeeAbsorbed: boolean;
	public IsmailFee: boolean = false;
	public agencyConfig: AgencyDmvConfigResponse;
	public mailFee: number;
	public countryName: string;
	public countryList: Countries;
	public deliveryMethod: string = null;
	public agencies: Agencies;
	public mailingText: string;
	public profileMap: Map<number, object> = new Map();
	public isAnyResNotExistInProfile: boolean = false;
	public userProfileDataLocal: Array<BillingAccount>;
	public notifyTo: string;
	ngOnInit() {
		AppUtil.log("DmvReviewCartComponent ngOnInit() == >");

		if (this.globalService.supportKioskPickup) {
			//this.notifyTo;
			if (
				this.dmvStoreService.registrationsInCart.pickupInPerson.email &&
				this.dmvStoreService.registrationsInCart.pickupInPerson.phone
			) {
				this.notifyTo = this.dmvStoreService.agencyConfig.agencyDmvConfig.reviewPageKioskPickupText3
					.replace(
						"*emailAddress*",
						this.dmvStoreService.registrationsInCart.pickupInPerson.email
					)
					.replace(
						"*phoneNumber*",
						this.dmvStoreService.registrationsInCart.pickupInPerson.phone
					);
			} else if (
				this.dmvStoreService.registrationsInCart.pickupInPerson.email
			) {
				this.notifyTo = this.dmvStoreService.agencyConfig.agencyDmvConfig.reviewPageKioskPickupText1.replace(
					"*emailAddress*",
					this.dmvStoreService.registrationsInCart.pickupInPerson.email
				);
			} else {
				this.notifyTo = this.dmvStoreService.agencyConfig.agencyDmvConfig.reviewPageKioskPickupText2.replace(
					"*phoneNumber*",
					this.dmvStoreService.registrationsInCart.pickupInPerson.phone
				);
			}
		}
		if (
			this.globalService.params &&
			this.globalService.params.deliveryMethodID
		) {
			this.globalService.params.deliveryMethodID = null;
		}
		this.dmvStoreService.addressrequired = false;
		this.megStoreService.configurationsData$.subscribe(data => {
			if (data && data.megConfig) {
				this.agencies = data.megConfig.agencies;
			}
		});
		let userProfileLocalData: UserProfile = null;
		this.userStoreService
			.userProfile$()
			.subscribe(data => {
				if (data) {
					userProfileLocalData = data;
					if (data.megUserGUID) {
						this.openloginModel = false;
					}
				}
			})
			.unsubscribe();

		if (
			userProfileLocalData &&
			userProfileLocalData.billingAccounts &&
			userProfileLocalData.billingAccounts.dmvAccounts
		) {
			this.userProfileDataLocal =
				userProfileLocalData.billingAccounts.dmvAccounts;
		}

		this.IsmailFee = false;
		this.dmvStoreService.agencyConfig$
			.subscribe(agencyConfig => {
				if (agencyConfig) {
					this.agencyConfig = agencyConfig;
					this.megAppFee =
						agencyConfig.agencyDmvConfig &&
						agencyConfig.agencyDmvConfig.megAppFee &&
						agencyConfig.agencyDmvConfig.megAppFee.amount
							? agencyConfig.agencyDmvConfig.megAppFee.amount
							: 0;
					//this.megAppFeeAbsorbed = agencyConfig.agencyDmvConfig.megAppFee.absorbed;
					this.setRenewalRequest();
				}
			})
			.unsubscribe();
		this.megStoreService.configurationsData$
			.subscribe(data => {
				if (data && data.megConfig) {
					this.countryList = data.megConfig.countries;
				}
			})
			.unsubscribe();
		this.updateMailFee();
		const countries = this.countryList.filter(item => {
			if (
				this.dmvStoreService.registrationsInCart &&
				this.dmvStoreService.registrationsInCart.mailingAddress &&
				this.dmvStoreService.registrationsInCart.mailingAddress.countryCode
			) {
				return (
					item.countryCode ===
					this.dmvStoreService.registrationsInCart.mailingAddress.countryCode
				);
			}
			return false;
		});
		if (countries && countries.length) {
			this.countryName = countries[0].name;
		}

		// this.userProfileDataLocal.forEach((data)=>{
		// 	this.profileMap.set(data.billingAccountID, {
		// 		isInProfile: true,
		// 	});
		// })
		this.isAnyResNotInProfile();
		this.createprofileMap();
		this.updateMailingText();
	}

	public updateAddress(customerNumber) {
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
		) {
			const firstRegistration = this.dmvStoreService.registrationsInCart
				.dmvRegistrations[0];
			if (
				!this.dmvStoreService.registrationsInCart.mailingAddress
					.updateAddressCheckBox
			) {
				if (customerNumber !== firstRegistration.registration.customerNumber) {
					this.deliveryMethod = "MX";
					this.dmvStoreService.registrationsInCart.mailingAddress.updateAddressCheckBox = true;
				}
			}
		} else {
			this.deliveryMethod = "MX";
			this.dmvStoreService.registrationsInCart.mailingAddress.updateAddressCheckBox = true;
		}
	}
	public updateMailingText() {
		let count: number = 0;
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
		) {
			count = this.dmvStoreService.registrationsInCart.dmvRegistrations.length;
		}

		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual &&
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.length
		) {
			count += this.dmvStoreService.registrationsInCart.dmvRegistrationsManual
				.length;
		}
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate &&
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.length
		) {
			count += this.dmvStoreService.registrationsInCart
				.dmvRegistrationsDuplicate.length;
		}
		if (count > 1) {
			this.dmvStoreService.registrationsInCart.mailingText =
				"Registrations and decals will be mailed to your address on file with the Department of Highways Safety and Motor Vehicles.";
		} else {
			this.dmvStoreService.registrationsInCart.mailingText =
				"Registration and decal will be mailed to your address on file with the Department of Highways Safety and Motor Vehicles.";
		}
	}
	public updateMailFee() {
		this.mailFee = 0;
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
		) {
			if (
				this.agencyConfig.agencyDmvConfig.mailFeeModel === "MAILONLY" &&
				this.dmvStoreService.registrationsInCart.mailingAddress
			) {
				this.IsmailFee = true;

				this.dmvStoreService.registrationsInCart.dmvRegistrations.forEach(
					DmvRegistrationItem => {
						if (
							DmvRegistrationItem.registration &&
							DmvRegistrationItem.registration.dmvFees
						) {
							DmvRegistrationItem.registration.dmvFees.forEach(dmvFee => {
								if (dmvFee.feeID === 1) {
									this.mailFee = this.mailFee + dmvFee.amount;
								}
							});
						}
					}
				);
			}
		}
	}
	ngAfterViewInit() {
		AppUtil.log("DmvReviewCartComponent ngAfterViewInit() == >");
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.position
		) {
			setTimeout(() => {
				window.scrollTo(0, this.dmvStoreService.routeFrom.position);
			});
		}
	}

	public removeRegistration(reg, index) {
		AppUtil.log("DmvReviewCartComponent removeRegistration() == >", reg);
		this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.filter(
			function(item) {
				return (
					item.registration.registrationID !== reg.registration.registrationID
				);
			}
		);
		this.dmvStoreService.registrationsInCart.selectedRegistrations = this.dmvStoreService.registrationsInCart.selectedRegistrations.filter(
			function(item) {
				return item.registrationID !== reg.registration.registrationID;
			}
		);
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length === 0
		) {
			if (
				!this.dmvStoreService.registrationsInCart.dmvRegistrationsManual ||
				(this.dmvStoreService.registrationsInCart.dmvRegistrationsManual &&
					this.dmvStoreService.registrationsInCart.dmvRegistrationsManual
						.length === 0)
			) {
				this.errorMessage =
					"There are no registration renewals in the shopping cart. Please add more.";
				this.globalService.cartNature = "TBD";
			} else {
				this.errorMessage = "";
			}
		}
		if (index === 0) {
			if (this.dmvStoreService.registrationsInCart.mailingAddress) {
				this.updateAddress(reg.registration.customerNumber);
			}
		}

		this.updateMailFee();
		this.updateMailingText();
	}

	public removeManualRenew(reg) {
		AppUtil.log("DmvReviewCartComponent removeManualRenew() == >", reg);
		this.dmvStoreService.registrationsInCart.dmvRegistrationsManual = this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.filter(
			function(item) {
				return item.tagNumber !== reg.tagNumber;
			}
		);
		if (
			(this.dmvStoreService.registrationsInCart.dmvRegistrations &&
				this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0) ||
			(this.dmvStoreService.registrationsInCart.dmvRegistrationsManual &&
				this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.length >
					0)
		) {
			this.errorMessage = "";
		} else {
			this.errorMessage =
				"There are no registration renewals in the shopping cart. Please add more.";
			this.globalService.cartNature = "TBD";
		}
		this.updateMailingText();
	}

	public removeDuplicate(reg) {
		AppUtil.log("DmvReviewCartComponent removeDuplicate() == >", reg);
		this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate = this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.filter(
			function(item) {
				return item.tagNumber !== reg.tagNumber;
			}
		);
		if (
			(this.dmvStoreService.registrationsInCart.dmvRegistrations &&
				this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0) ||
			(this.dmvStoreService.registrationsInCart.dmvRegistrationsManual &&
				this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.length >
					0) ||
			(this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate &&
				this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate
					.length > 0)
		) {
			this.errorMessage = "";
		} else {
			this.errorMessage =
				"There are no registration renewals in the shopping cart. Please add more.";
			this.globalService.cartNature = "TBD";
		}
		this.updateMailingText();
	}

	public editRegistration(page, event) {
		AppUtil.log("DmvReviewCartComponent editRegistration() == >", page, event);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "dmv-review-cart";
		this.dmvStoreService.routeFrom.orderNumber = page;
		this.dmvStoreService.routeFrom.position = window.scrollY;
		this.router.navigate(["dmv-customize-order"], {
			skipLocationChange: true
		});
	}
	public editManualRenew(page, event) {
		AppUtil.log("DmvReviewCartComponent editManualRenew() == >", page, event);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "dmv-review-cart";
		this.dmvStoreService.routeFrom.orderNumber = page;
		this.dmvStoreService.routeFrom.position = window.scrollY;
		this.router.navigate(["dmv-manual-renew"], {
			skipLocationChange: true
		});
	}

	public editDuplicate(page, event) {
		AppUtil.log("DmvReviewCartComponent editDuplicate() == >", page, event);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "dmv-review-cart";
		this.dmvStoreService.routeFrom.orderNumber = page;
		this.dmvStoreService.routeFrom.position = window.scrollY;
		this.router.navigate(["dmv-duplicate"], {
			skipLocationChange: true
		});
	}

	public removeDonation() {
		AppUtil.log("DmvReviewCartComponent removeDonation() == >");
		this.dmvStoreService.registrationsInCart.donation = null;
	}

	public editDonation(event) {
		AppUtil.log("DmvReviewCartComponent editDonation() == >", event);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "dmv-review-cart";
		this.dmvStoreService.routeFrom.orderNumber = null;
		this.dmvStoreService.routeFrom.position = window.scrollY;

		this.router.navigate(["dmv-donation"], {
			skipLocationChange: true
		});
	}

	public editPickupInPerson(event) {
		AppUtil.log("DmvReviewCartComponent editPickupInPerson() == >", event);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "dmv-review-cart";
		this.dmvStoreService.routeFrom.orderNumber = null;
		this.dmvStoreService.routeFrom.position = window.scrollY;
		this.router.navigate(["dmv-pickup-in-person"], {
			skipLocationChange: true
		});
	}

	public editMailingAddress(event) {
		AppUtil.log("DmvReviewCartComponent editMailingAddress() == >", event);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "dmv-review-cart";
		this.dmvStoreService.routeFrom.orderNumber = null;
		this.dmvStoreService.routeFrom.position = window.scrollY;
		if (
			this.dmvStoreService.agencyConfig.agencyDmvConfig.allowAddressUpdate ||
			this.dmvStoreService.agencyConfig.agencyDmvConfig
				.allowMailingToTempAddress
		) {
			this.router.navigate(["dmv-pickup-mailing"], {
				skipLocationChange: true
			});
		} else {
			this.router.navigate(["dmv-pickup-method"], {
				skipLocationChange: true
			});
		}
	}

	public addAnotherItem() {
		AppUtil.log("DmvReviewCartComponent addAnotherItem() == >");
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "add-another";
		if (this.dmvStoreService.registrationsInCart.dmvRegistrations) {
			this.dmvStoreService.routeFrom.orderNumber = this.dmvStoreService.registrationsInCart.dmvRegistrations.length;
		}
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length === 0
		) {
			if (
				!this.dmvStoreService.registrationsInCart.dmvRegistrationsManual ||
				(this.dmvStoreService.registrationsInCart.dmvRegistrationsManual &&
					this.dmvStoreService.registrationsInCart.dmvRegistrationsManual
						.length === 0)
			) {
				this.dmvStoreService.addressrequired = true;
				if (this.dmvStoreService.registrationsInCart.mailingAddress) {
					this.dmvStoreService.registrationsInCart.mailingAddress.updateAddressCheckBox = false;
				}
				//	}
			}
		}
		//  else if (
		// 	this.dmvStoreService.registrationsInCart.dmvRegistrationsManual
		// ) {
		// 	this.dmvStoreService.routeFrom.orderNumber = this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.length;
		// }
		this.dmvStoreService.routeFrom.position = window.scrollY;

		this.router.navigate(["dmv-search"], {
			skipLocationChange: true
		});
	}
	public goBack() {
		AppUtil.log("DmvReviewCartComponent goBack() == >");
		this.dmvStoreService.routeFrom = null;
		this.router.navigate(["dmv-customize-order"], {
			skipLocationChange: true
		});
		// if(!this.dmvStoreService.registrationsInCart.firstIteration){
		// 		this.router.navigate(["dmv-customize-order"]);
		// }else if(this.dmvStoreService.registrationsInCart.mailingAddress){
		// 	this.router.navigate(["dmv-pickup-mailing"]);
		// }else{
		// 	this.router.navigate(["dmv-pickup-in-person"]);
		// }
	}

	public setRenewalRequest() {
		AppUtil.log("DmvReviewCartComponent setRenewalRequest() == >");
		//	this.renewalRequest.renewalToken = this.dmvStoreService.registrationsInCart.renewalToken;
		//this.renewalReques.serviceProviderFee
		this.renewalRequest.renewalItems = [];
		if (this.dmvStoreService.registrationsInCart.dmvRegistrations) {
			this.dmvStoreService.registrationsInCart.dmvRegistrations.forEach(
				(item: DmvRegistration) => {
					const renewalItem: RenewalItem = {};
					renewalItem.registrationID = item.registration.registrationID;
					renewalItem.licensePlate = item.registration.licensePlate;
					renewalItem.registrationType = item.registration.registrationType;
					renewalItem.dmvCostData = {};

					if (
						(this.dmvStoreService.agencyConfig.agencyDmvConfig.mailFeeModel ===
							"MAILONLY" &&
							this.dmvStoreService.registrationsInCart.pickupInPerson) ||
						this.dmvStoreService.agencyConfig.agencyDmvConfig.mailFeeModel ===
							"NEVER"
					) {
						let dmvFees = item.registration.dmvFees;
						if (dmvFees) {
							dmvFees = dmvFees.filter(function(fee) {
								return fee.feeID !== 1;
							});
						}
						renewalItem.dmvCostData.dmvFees = dmvFees;
					} else {
						renewalItem.dmvCostData.dmvFees = item.registration.dmvFees;
					}
					//renewalItem.dmvCostData.dmvFees = item.registration.dmvFees;

					renewalItem.dmvCostData.renewalCost = item.registration.renewalCost;

					let mailFeeAmount = 0;
					if (
						this.dmvStoreService.agencyConfig.agencyDmvConfig.mailFeeModel ===
							"MAILONLY" &&
						this.dmvStoreService.registrationsInCart.mailingAddress
					) {
						item.registration.dmvFees.forEach(dmvFee => {
							if (dmvFee.feeID === 1) {
								mailFeeAmount = mailFeeAmount + dmvFee.amount;
							}
						});
					}

					renewalItem.dmvCostData.totalAmountDue = item.registration
						.totalAmountDue
						? Number(
								(mailFeeAmount + item.registration.totalAmountDue).toFixed(2)
							)
						: mailFeeAmount + item.registration.totalAmountDue;

					renewalItem.renewalOptionID = item.selectedRenewalOption;
					if (item.isPlateChange) {
						renewalItem.newTagCode = item.registration.currentTagCode;
					}
					renewalItem.insuranceData = item.globalInsuranceData;
					this.renewalRequest.renewalItems.push(renewalItem);
				}
			);
		}
		if (this.dmvStoreService.registrationsInCart.dmvRegistrationsManual) {
			// if (!this.renewalRequest.renewalItems) {
			// 	this.renewalRequest.renewalItems = [];
			// }

			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.forEach(
				(item: DmvRegistrationManual) => {
					const renewalItem: RenewalItem = {};
					renewalItem.registrationType = item.vechicleType;
					renewalItem.licensePlate = item.tagNumber;
					renewalItem.expirationDate = item.expirationDate;
					if (
						item.insuranceIdNo &&
						item.insuranceCompany &&
						item.insurancePolicyNo
					) {
						renewalItem.insuranceData = {};
						renewalItem.insuranceData.companyCode = item.insuranceIdNo;
						renewalItem.insuranceData.companyName = item.insuranceCompany;
						renewalItem.insuranceData.policyNumber = item.insurancePolicyNo;
					}

					renewalItem.renewalOptionID = 1;

					renewalItem.dmvCostData = {};
					renewalItem.dmvCostData.totalAmountDue = item.amount + item.lateFee;

					renewalItem.dmvCostData.totalAmountDue = renewalItem.dmvCostData
						.totalAmountDue
						? Number(renewalItem.dmvCostData.totalAmountDue.toFixed(2))
						: renewalItem.dmvCostData.totalAmountDue;

					renewalItem.dmvCostData.renewalCost = item.amount;
					renewalItem.dmvCostData.dmvFees = [];
					const dmvFees: DmvFee = {};
					dmvFees.feeID = 3;
					dmvFees.amount = item.lateFee;
					dmvFees.displaySequence = 1;
					renewalItem.dmvCostData.dmvFees.push(dmvFees);
					this.renewalRequest.renewalItems.push(renewalItem);
				}
			);
		}

		if (this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate) {
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.forEach(
				(item: DmvRegistrationDuplicate) => {
					const renewalItem: RenewalItem = {};
					renewalItem.registrationType = item.vechicleType;
					renewalItem.licensePlate = item.tagNumber;
					renewalItem.expirationDate = item.expirationDate;

					renewalItem.renewalOptionID = 10;

					renewalItem.dmvCostData = item.dmvCostData;

					this.renewalRequest.renewalItems.push(renewalItem);
				}
			);
		}

		if (this.dmvStoreService.registrationsInCart.donation) {
			this.renewalRequest.donations = [];
			this.renewalRequest.donations.push(
				this.dmvStoreService.registrationsInCart.donation
			);
		} else {
			this.renewalRequest.donations = undefined;
		}

		// if (this.megAppFee) {
		this.renewalRequest.megAppFee = this.megAppFee;
		// }
		//this.renewalRequest.megAppFeeAbsorbed = this.megAppFeeAbsorbed;

		if (this.dmvStoreService.registrationsInCart.pickupInPerson) {
			if (this.globalService.supportKioskPickup) {
				this.renewalRequest.pickupLocationID =
					"" +
					this.dmvStoreService.agencyConfig.agencyDmvConfig
						.kioskPickupLocationID;
				if (this.dmvStoreService.registrationsInCart.pickupInPerson.phone) {
					this.renewalRequest.pickupPhoneNumber = this.dmvStoreService.registrationsInCart.pickupInPerson.phone
						.replace(/[^\w\s]/gi, "")
						.replace(/ /g, "");
				}
				if (this.dmvStoreService.registrationsInCart.pickupInPerson.email) {
					this.renewalRequest.pickupEmailAddress = this.dmvStoreService.registrationsInCart.pickupInPerson.email;
				}
			} else {
				this.renewalRequest.pickupLocationID =
					"" +
					this.dmvStoreService.registrationsInCart.pickupInPerson.pickupLocation
						.locationID;
				if (
					this.dmvStoreService.registrationsInCart.pickupInPerson
						.authorizedPerson
				) {
					this.renewalRequest.pickupPersonName = this.dmvStoreService.registrationsInCart.pickupInPerson.authorizedPerson;
				}
			}

			this.renewalRequest.deliveryMethod = "PU";
		}

		if (this.dmvStoreService.registrationsInCart.mailingAddress) {
			const mailToAddress: Address = {};
			this.renewalRequest.mailToName = this.dmvStoreService.registrationsInCart.mailingAddress.registrantName;
			mailToAddress.line1 = this.dmvStoreService.registrationsInCart.mailingAddress.billigAddress1;
			mailToAddress.line2 = this.dmvStoreService.registrationsInCart.mailingAddress.billigAddress2;
			mailToAddress.city = this.dmvStoreService.registrationsInCart.mailingAddress.city;
			mailToAddress.countryCode = this.dmvStoreService.registrationsInCart.mailingAddress.countryCode;
			mailToAddress.postalCode = this.dmvStoreService.registrationsInCart.mailingAddress.zip;
			mailToAddress.stateCode = this.dmvStoreService.registrationsInCart.mailingAddress.state;

			this.renewalRequest.updateAddressOnFile = this.dmvStoreService.registrationsInCart.mailingAddress.updateAddress;

			if (this.dmvStoreService.registrationsInCart.dmvRegistrations) {
				if (
					this.dmvStoreService.registrationsInCart.mailingAddress
						.updateAddressCheckBox ||
					this.dmvStoreService.registrationsInCart.mailingAddress
						.tempAddressChange ||
					this.dmvStoreService.registrationsInCart.mailingAddress
						.permAddressUpdate
				) {
					this.renewalRequest.deliveryMethod = "MX";
					this.renewalRequest.mailToAddress = mailToAddress;
				} else {
					this.renewalRequest.deliveryMethod = "MF";
				}
			} else if (
				this.dmvStoreService.registrationsInCart.dmvRegistrationsManual
			) {
				this.renewalRequest.deliveryMethod = "MX";
				this.renewalRequest.mailToAddress = mailToAddress;
			}
			if (
				this.dmvStoreService.registrationsInCart.addressComefrom === "manual"
			) {
				this.renewalRequest.deliveryMethod = "MX";
				this.renewalRequest.mailToAddress = mailToAddress;
			}
			if (this.deliveryMethod) {
				this.renewalRequest.deliveryMethod = "MX";
			}
		}
		if (this.deliveryMethod) {
			this.renewalRequest.deliveryMethod = "MX";
		}
		//this.renewalRequest.fundingToken =
		//this.renewalRequest.notificationOptions =
		//this.renewalRequest.comment =
		AppUtil.log(
			"DmvReviewCartComponent setRenewalRequest() == > renewalRequest",
			this.renewalRequest
		);
		this.dmvStoreService.registrationsInCart.renewalRequest = this.renewalRequest;
	}

	public callPaymentAccessToken(renewalRequest, agencyID) {
		AppUtil.log(
			"DmvReviewCartComponent callPaymentAccessToken() == > renewalRequest, agencyID",
			renewalRequest,
			agencyID
		);

		this.dmvDataService
			.getPaymentAccessTokenResponse(agencyID, this.dmvStoreService.sessionID)
			.subscribe(
				response => {
					AppUtil.log(
						"DmvReviewCartComponent callPaymentAccessToken() == > response",
						response
					);
					if (response) {
						if (response.accessToken) {
							this.isloading = true;
							this.dmvStoreService.registrationsInCart.accessToken =
								response.accessToken;
							if (
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.serviceProviderID === 2
							) {
								this.router.navigate(["gsg-payment"], {
									skipLocationChange: true
								});
							} else if (
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.serviceProviderID === 3
							) {
								this.router.navigate(["meg-payment"], {
									skipLocationChange: true
								});
							} else {
								if (
									AppConfigUtil.getProperties() &&
									AppConfigUtil.getProperties().DirectWebComponentAccess &&
									AppConfigUtil.getProperties().DirectWebComponentAccess ===
										true
								) {
									this.router.navigate(["pnp-payment"], {
										skipLocationChange: true
									});
									//this.router.navigate(["dmv-review-cart-with-billing"], { skipLocationChange: true });
								} else {
									this.router.navigate(["payment"], {
										skipLocationChange: true
									});
									//this.router.navigate(["dmv-review-cart-with-billing"], { skipLocationChange: true });
								}
							}

							this.cd.markForCheck();
						} else {
							this.errorMessage = "Some error occurred, please try again.";
							this.isloading = false;
							this.cd.markForCheck();
						}
					}
				},
				error => {
					AppUtil.log(
						"DmvReviewCartComponent callPaymentAccessToken() == > error",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;
						this.isloading = false;
						this.cd.markForCheck();
					}
				}
			);
	}

	public continue() {
		AppUtil.log("DmvReviewCartComponent continue() == > ");
		if (
			(this.dmvStoreService.registrationsInCart.dmvRegistrations &&
				this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0) ||
			(this.dmvStoreService.registrationsInCart.dmvRegistrationsManual &&
				this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.length >
					0) ||
			(this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate &&
				this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate
					.length > 0)
		) {
			this.setRenewalRequest();
			//this.isloading = true;
			const _this = this;
			if (
				this.userStoreService.getUserProfile() &&
				this.userStoreService.getUserProfile().megUserGUID &&
				this.userStoreService.getUserProfile().paymentDevices &&
				this.userStoreService.getUserProfile().paymentDevices.length > 0 &&
				this.userStoreService
					.getUserProfile()
					.paymentDevices.filter(function(item) {
						return (
							Number(_this.dmvStoreService.selectedAgencyId) === item.agencyID
						);
					}).length > 0
			) {
				this.router.navigate(["select-payment-method"], {
					skipLocationChange: true
				});
			} else {
				if (
					this.dmvStoreService.agencyConfig.agencyDmvConfig
						.serviceProviderID === 2
				) {
					this.router.navigate(["gsg-payment"], { skipLocationChange: true });
				} else if (
					this.dmvStoreService.agencyConfig.agencyDmvConfig
						.serviceProviderID === 3
				) {
					this.router.navigate(["meg-payment"], {
						skipLocationChange: true
					});
				} else {
					if (
						AppConfigUtil.getProperties() &&
						AppConfigUtil.getProperties().DirectWebComponentAccess &&
						AppConfigUtil.getProperties().DirectWebComponentAccess === true
					) {
						this.router.navigate(["pnp-payment"], { skipLocationChange: true });
					} else {
						this.router.navigate(["payment"], { skipLocationChange: true });
					}
				}
			}
			this.cd.markForCheck();
			// this.callPaymentAccessToken(
			// 	this.renewalRequest,
			// 	this.agencyConfig.agencyDmvConfig.agencyID
			// );

			//this.router.navigate(["dmv-review-cart-with-billing"]);
		} else {
			this.errorMessage =
				"There are no renewals in your shopping cart.  Please add one or more items before continuing.";
			this.globalService.cartNature = "TBD";
		}
	}

	public no() {
		this.openRennewalReminderModel = false;
		this.dmvStoreService.addToProfileState = "no";
		this.addToProfileCall();
	}
	public yes() {
		this.openRennewalReminderModel = false;
		this.dmvStoreService.addToProfileState = "yes";
		this.addToProfileCall();
	}
	public addToProfile(registration: Registration) {
		this.addToProfileRegistraion = registration;
		const userProfile = this.userStoreService.getUserProfile();
		if (
			!this.dmvStoreService.addToProfileState &&
			!(
				userProfile &&
				userProfile.notificationSettings &&
				userProfile.notificationSettings.notificationTypes &&
				userProfile.notificationSettings.notificationTypes.dmv
			)
		) {
			this.openRennewalReminderModel = true;
		} else {
			this.addToProfileCall();
		}
	}
	public addToProfileCall() {
		const request: BillingAccount = Object.assign({});
		request.billingAccountID = 0;
		request.productTypeID = 1;
		request.agencyID = Number(this.agencyConfig.agencyDmvConfig.agencyID);
		request.agency = this.getagencyById(
			this.agencyConfig.agencyDmvConfig.agencyID
		);
		const billingAccountFields: Array<BillingAccountField> = Object.assign([]);
		const billingAccountField: BillingAccountField = Object.assign({});
		billingAccountField.fieldID = 1;
		billingAccountField.value = this.addToProfileRegistraion.licensePlate;
		billingAccountFields.push(billingAccountField);

		if (this.addToProfileRegistraion.pinNumber) {
			const billingAccountField2: BillingAccountField = Object.assign({});
			billingAccountField2.fieldID = 2;
			billingAccountField2.value = this.addToProfileRegistraion.pinNumber;
			billingAccountFields.push(billingAccountField2);
		}

		const billingAccountField3: BillingAccountField = Object.assign({});
		billingAccountField3.fieldID = 3;
		billingAccountField3.value = this.addToProfileRegistraion.makeModel;
		billingAccountFields.push(billingAccountField3);

		if (this.addToProfileRegistraion.dateOfBirth) {
			const billingAccountField4: BillingAccountField = Object.assign({});
			billingAccountField4.fieldID = 4;
			billingAccountField4.value = this.addToProfileRegistraion.dateOfBirth;
			billingAccountFields.push(billingAccountField4);
		}

		if (this.addToProfileRegistraion.expirationDate) {
			const billingAccountField5: BillingAccountField = Object.assign({});
			billingAccountField5.fieldID = 5;
			billingAccountField5.value = this.addToProfileRegistraion.expirationDate;
			billingAccountFields.push(billingAccountField5);
		}
		if (this.addToProfileRegistraion.customerNumber) {
			const billingAccountField6: BillingAccountField = Object.assign({});
			billingAccountField6.fieldID = 6;
			billingAccountField6.value = this.addToProfileRegistraion.customerNumber.toString();
			billingAccountFields.push(billingAccountField6);
		}
		if (this.addToProfileRegistraion.registrationType) {
			const billingAccountField7: BillingAccountField = Object.assign({});
			billingAccountField7.fieldID = 7;
			billingAccountField7.value = this.addToProfileRegistraion.registrationType;
			billingAccountFields.push(billingAccountField7);
		}

		let optForReminder;
		request.billingAccountFields = billingAccountFields;
		if (this.dmvStoreService.addToProfileState === "yes") {
			optForReminder = "true";
		} else if (this.dmvStoreService.addToProfileState === "no") {
			optForReminder = "false";
		}

		this.isloading = true;
		this.userStoreService.outComeText = "";
		this.userDataService
			.addBillingAccount(
				this.dmvStoreService.sessionGUID,
				this.userStoreService.getUserProfile().megUserGUID,
				request,
				optForReminder
			)
			.subscribe(
				response => {
					AppUtil.log("addBillingAccount() ==>", response);
					if (response) {
						this.isloading = false;
						if (response.statusCode === 200) {
							this.profileMap.set(this.addToProfileRegistraion.registrationID, {
								isDisbled: true,
								type: "success",
								text: response.OutcomeText
							});
							const userProfile = this.userStoreService.getUserProfile();

							if (userProfile.billingAccounts == null) {
								userProfile.billingAccounts = Object.assign({});
							}
							if (userProfile.billingAccounts.dmvAccounts == null) {
								userProfile.billingAccounts.dmvAccounts = [];
							}

							userProfile.billingAccounts.dmvAccounts.push(request);

							this.userStoreService.setUserProfileFromResponse(
								response,
								userProfile
							);
							//	this.userStoreService.setUserProfile(userProfile);
							this.isAnyResNotInProfile();
						} else {
							this.profileMap.set(this.addToProfileRegistraion.registrationID, {
								isDisbled: false,
								text: response.OutcomeText,
								type: "failed"
							});
						}
						this.cd.detectChanges();
					}
				},
				error => {
					AppUtil.log("deleteBillingAccount()==> error:", error);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.profileMap.set(this.addToProfileRegistraion.registrationID, {
							isDisbled: false,
							text: "Sorry, it did not work.",
							type: "failed"
						});
						this.isloading = false;
						this.cd.markForCheck();
					}
				}
			);
	}
	public getagencyById(id) {
		const _this = this;
		const agency = this.agencies.filter(function(item) {
			return item.agencyID === id;
		});

		if (agency && agency.length > 0) {
			return agency[0].name;
		} else {
			return "";
		}
	}
	public getLicensePlate(data) {
		const billingAccountFields = data.billingAccountFields.filter(function(
			item
		) {
			return item.fieldID === 1;
		});
		return billingAccountFields[0];
	}
	public isInProfile(registration: Registration, checkForAll?) {
		let isExist = false;
		let dmvAccounts = [];
		if (checkForAll) {
			if (this.userStoreService.getUserProfile().billingAccounts) {
				dmvAccounts = this.userStoreService.getUserProfile().billingAccounts
					.dmvAccounts;
			}
		} else {
			dmvAccounts = this.userProfileDataLocal;
		}
		if (dmvAccounts) {
			dmvAccounts.forEach(dmvAccount => {
				if (
					dmvAccount.agencyID ===
						Number(this.agencyConfig.agencyDmvConfig.agencyID) &&
					registration.licensePlate === this.getLicensePlate(dmvAccount).value
				) {
					isExist = true;
					let profileMapObj = this.profileMap.get(registration.registrationID);
					if (!profileMapObj) {
						profileMapObj = {};
					}
					profileMapObj["isDisbled"] = true;
					this.profileMap.set(registration.registrationID, profileMapObj);
				}
			});
		}

		return isExist;
	}

	public createprofileMap() {
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().megUserGUID &&
			this.userStoreService.getUserProfile().billingAccounts &&
			this.userStoreService.getUserProfile().billingAccounts.dmvAccounts
		) {
			if (
				this.dmvStoreService.registrationsInCart.dmvRegistrations &&
				this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
			) {
				this.dmvStoreService.registrationsInCart.dmvRegistrations.forEach(
					dmvRegistration => {
						if (this.isInProfile(dmvRegistration.registration, true)) {
							let profileMapObj = this.profileMap.get(
								dmvRegistration.registration.registrationID
							);
							if (!profileMapObj) {
								profileMapObj = {};
							}
							profileMapObj["inInProfile"] = true;
							this.profileMap.set(
								dmvRegistration.registration.registrationID,
								profileMapObj
							);
						}
					}
				);
			}
		}
	}
	public transformMessage(htmlStr) {
		if (htmlStr) {
			htmlStr = htmlStr.replace("*accounts*", "registrations");
			htmlStr = htmlStr.replace("*transactions*", "renewals");
		}
		return htmlStr;
	}
	public isAnyResNotInProfile() {
		let isExist = false;
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().megUserGUID
		) {
			if (
				this.dmvStoreService.registrationsInCart.dmvRegistrations &&
				this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
			) {
				this.dmvStoreService.registrationsInCart.dmvRegistrations.forEach(
					dmvRegistration => {
						if (!this.isInProfile(dmvRegistration.registration, true)) {
							isExist = true;
						}
					}
				);
			}
		}
		this.isAnyResNotExistInProfile = isExist;
		this.cd.detectChanges();
	}

	public noThanks() {
		this.userStoreService.loginPopupRequest = false;
		this.openloginModel = false;
	}
	public logIn() {
		this.userStoreService.loginPopupRequest = false;
		this.openloginModel = false;

		this.userStoreService.accountCreateFormData = null;
		this.router.navigate(["log-in"], { skipLocationChange: true });
	}
	public register() {
		this.userStoreService.loginPopupRequest = false;
		this.openloginModel = false;
		this.userStoreService.accountfromLogin = false;
		this.userStoreService.accountCreateFormData = null;
		this.router.navigate(["create-account"], { skipLocationChange: true });
	}
}
